/**
 * Envío PJ-1 · reparto del proyecto abierto y personaje en edición.
 * Sin consultas periódicas: se carga al abrir el panel o al cambiar de proyecto.
 */
import { create } from 'zustand';
import { characterService } from '../services/characterService';

export const useCharacterStore = create((set, get) => ({
  projectId: null,
  cast: [],           // [{id, name, handle, cover_url, project_role, ...}]
  characters: null,   // mis personajes (resumen, con foto)
  current: null,      // {character, card} del que se está editando
  loading: false,

  async loadCast(projectId, { force = false } = {}) {
    if (!projectId) { set({ projectId: null, cast: [] }); return; }
    if (!force && get().projectId === projectId && get().loading) return;
    set({ projectId, loading: true });
    try {
      const cast = await characterService.cast(projectId);
      if (get().projectId === projectId) set({ cast, loading: false });
    } catch {
      if (get().projectId === projectId) set({ cast: [], loading: false });
    }
  },

  async loadList() {
    try { set({ characters: await characterService.list() }); } catch { set({ characters: [] }); }
  },

  async open(ref) {
    const out = await characterService.get(ref);
    set({ current: out });
    return out;
  },

  close() { set({ current: null }); },

  async addToCast(projectId, ref, role) {
    const cast = await characterService.changeCast(projectId, { add: [{ character: ref, role }] });
    set({ cast });
  },

  async removeFromCast(projectId, ref) {
    const cast = await characterService.changeCast(projectId, { remove: [ref] });
    set({ cast });
  },

  async create(projectId, payload) {
    const out = await characterService.create({ ...payload, project_id: projectId });
    set({ current: out });
    await get().loadCast(projectId, { force: true });
    get().loadList();
    return out;
  },

  async update(patch) {
    const c = get().current?.character;
    if (!c) return null;
    const out = await characterService.update(c.id, patch);
    set({ current: out });
    if (get().projectId) get().loadCast(get().projectId, { force: true });
    return out;
  },

  async undo() {
    const c = get().current?.character;
    if (!c) return null;
    const out = await characterService.undo(c.id);
    set({ current: out });
    return out;
  },

  reset() { set({ projectId: null, cast: [], characters: null, current: null }); },
}));

export default useCharacterStore;
